import { VENDOR_URL } from "api/urls"

export const useVendorOpen = () => {
  const getAllNecessaryParamsForVendorApp = () => {
    const params = new URLSearchParams()

    params.append("return_path", window.location.href)

    if (localStorage.getItem("policy")) {
      params.append("policy", "1")
    }

    return params.size ? `?${params.toString()}` : ""
  }

  const gotoRegPage = () => {
    window.open(`${VENDOR_URL}/registration${getAllNecessaryParamsForVendorApp()}`, "_blank")
  }

  const gotoLoginPage = () => {
    window.open(`${VENDOR_URL}/login${getAllNecessaryParamsForVendorApp()}`, "_blank")
  }

  return {
    gotoRegPage,
    gotoLoginPage,
  }
}
